import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('navToggler');
loader('langToggler');
loader('gformDatalayer');
loader('instantSearch', '.product-archive');
loader('plyr');
loader('slider', '.swiper');
loader('footer', '.footer');
loader('gfield', '.gfield');
loader('accordion', '.accordion');
loader('news-search', '.news-search');
loader('cases-search', '.cases-search');
loader('clipboard', '.copylink');
loader('toggleDropdown', '.menu__dropdown-toggle');
loader('table', 'table');
loader('softwareSolutions', '.software-solutions');
loader('videoBlock', '.video-locked__frame');
loader('tabbedTextImage', '.tabbed-text-image');

loader('instantSearch', '.product-archive');
loader('search', '.search-container');
loader('search-results', '.search-results');
loader('search-results', '.search-no-results');
loader('popup', '.popup');
loader('select', 'select[multiple]');

// Svelte objects
loader('dropdowns', '#navigation-svelte');
